import React from "react";
import { Link } from "react-scroll";

const TableOfContents = ({ location }) => {
  return (
    <nav className="toc">
      <div className="toc-name">Table of contents</div>
      <ol>
        <li className="item">
          <Link
            activeClass="active"
            to="1"
            spy={true}
            smooth={true}
            offset={-150}
            delay={120}
            duration={400}
          >
            +60 Free Social Media Templates
          </Link>
        </li>
        <ul>
          <li className="item">
            <Link
              activeClass="active"
              to="1-1"
              spy={true}
              smooth={true}
              offset={-150}
              delay={120}
              duration={400}
            >
              Social Media Templates for Facebook
            </Link>
          </li>
          <li className="item">
            <Link
              activeClass="active"
              to="1-2"
              spy={true}
              smooth={true}
              offset={-150}
              delay={120}
              duration={400}
            >
              Social Media Templates for LinkedIn
            </Link>
          </li>
          <li className="item">
            <Link
              activeClass="active"
              to="1-3"
              spy={true}
              smooth={true}
              offset={-150}
              delay={120}
              duration={400}
            >
              Social Media Templates for Twitter
            </Link>
          </li>
          <li className="item">
            <Link
              activeClass="active"
              to="1-4"
              spy={true}
              smooth={true}
              offset={-150}
              delay={120}
              duration={400}
            >
              Twitch Image Sizes
            </Link>
          </li>
          <ul>
            <li>
              <Link
                activeClass="active"
                to="1-4-1"
                spy={true}
                smooth={true}
                offset={-150}
                delay={120}
                duration={400}
              >
                Twitch profile picture
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="1-4-2"
                spy={true}
                smooth={true}
                offset={-150}
                delay={120}
                duration={400}
              >
                Twitch cover image and header size
              </Link>
            </li>
          </ul>
          <li className="item">
            <Link
              activeClass="active"
              to="1-5"
              spy={true}
              smooth={true}
              offset={-150}
              delay={120}
              duration={400}
            >
              How to make good content for Social Media
            </Link>
          </li>
          <ul>
            <li>
              <Link
                activeClass="active"
                to="1-5-1"
                spy={true}
                smooth={true}
                offset={-150}
                delay={120}
                duration={400}
              >
                1. Get peoples attention
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="1-5-2"
                spy={true}
                smooth={true}
                offset={-150}
                delay={120}
                duration={400}
              >
                2. Keep it short. Use simple words.
              </Link>
            </li>
            <li>
              <Link
                activeClass="active"
                to="1-5-3"
                spy={true}
                smooth={true}
                offset={-150}
                delay={120}
                duration={400}
              >
                3. Test, test. test.
              </Link>
            </li>
          </ul>
        </ul>
      </ol>
    </nav>
  );
};

export default TableOfContents;
